import { ReadMoreLink } from '@/components/common/ReadMoreLink'
import { ARTICLE_URLS } from '@/defs/misc'
import { type RecType } from '@/defs/rec'
import { formatZScore } from '@/utils/formatUtil'
import { getRecName } from '@/utils/recUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'
import { StatCommonFigure } from '../../StatCommon/StatCommonFigure/StatCommonFigure'

type Props = {
  isInView?: boolean
  rec: RecType
}

export const StatRecZScore = ({ isInView, rec }: Props) => {
  const { trendZscore } = rec
  const fullName = getRecName(rec)

  const icon = trendZscore !== undefined && trendZscore < 1 ? '❄️' : '🔥'

  const popover = trendZscore !== undefined && (
    <>
      <h2>Fire Score</h2>
      <p>
        The Fire Score identifies cards that are either significantly increasing or decreasing in usage with a given
        commander relative to other cards played with that commander over the most recent six months.
      </p>
      {trendZscore > 1 && (
        <p>
          {fullName} is <strong>trending</strong>!
          {Array.from({ length: Math.min(4, Math.max(0, Math.floor(trendZscore - 1))) }, (_, i) => (
            <span aria-label='fire' key={i} role='img'>
              🔥
            </span>
          ))}
        </p>
      )}
      <p>
        <ReadMoreLink as='LinkOutbound' href={ARTICLE_URLS.FIERY} />
      </p>
    </>
  )

  return (
    <StatCommonBox isInView={isInView} label='Fire Score' popover={popover}>
      {trendZscore !== undefined && (
        <StatCommonFigure icon={icon} size='sm'>
          {formatZScore(trendZscore)}
        </StatCommonFigure>
      )}
    </StatCommonBox>
  )
}
